import type { FC } from 'react';

import { Modal, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

export const ViewNoteModal: FC<{ comment: string; onCancel: () => void }> = ({
  onCancel,
  comment,
}) => {
  return (
    <Modal
      header={
        <Typography variant="h4" style={{ fontSize: 22, fontWeight: '500' }}>
          Note
        </Typography>
      }
      closeIconStyle={{
        width: 24,
        height: 24,
      }}
      modalKey={MODAL_KEY.VIEW_NOTE}
      submitButton={{ hide: true }}
      cancelButton={{ hide: true }}
      onCancel={onCancel}
    >
      <Typography variant="body-2" style={{ fontSize: 18 }}>
        {comment}
      </Typography>
    </Modal>
  );
};
